export const normal = 400
export const semibold = 500
